import type { RefObject } from 'react';
import { useLayoutEffect } from 'react';

import { CALENDAR_CONFIG } from '../utils/calendarConfig';

const MAX_ATTEMPTS = 60;

export const useCalendarScroll = (
  containerRef: RefObject<HTMLElement>,
  scrollToMinutes: number,
  date: Date
): void => {
  useLayoutEffect(() => {
    let frame = 0;
    let attempts = 0;

    const tryScroll = () => {
      const timeView =
        containerRef.current?.querySelector<HTMLElement>('.rbc-time-view');
      const group = containerRef.current?.querySelector<HTMLElement>(
        '.rbc-time-content .rbc-timeslot-group'
      );

      const isScrollable =
        !!timeView &&
        !!group &&
        group.offsetHeight > 0 &&
        timeView.scrollHeight > timeView.clientHeight;

      if (isScrollable) {
        const minutesPerGroup =
          CALENDAR_CONFIG.STEP * CALENDAR_CONFIG.TIMESLOTS;

        timeView.scrollTop =
          (scrollToMinutes / minutesPerGroup) * group.offsetHeight;

        return;
      }

      if (attempts < MAX_ATTEMPTS) {
        attempts += 1;
        frame = requestAnimationFrame(tryScroll);
      }
    };

    tryScroll();

    return () => cancelAnimationFrame(frame);
  }, [containerRef, scrollToMinutes, date]);
};
